module.exports = __webpack_public_path__ + "static/anika_jagow-b99dbe31bf92048d2c7fc19ec4b6edf1.pdf";